import { animation, keyframes } from "./animations.js";
import { baseColours } from "./colourDefinitions.js";
import { removeAlpha } from "./colourHelpers.js";
import { screens } from "./screens.js";
export * from "./colourDefinitions.js";
export * from "./colourHelpers.js";
export * from "./screens.js";
/**
 * Get the tailwind theme for the Rootree design system
 *
 * @deprecated Please use the CSS-first configuration.
 * @param preserveColours Whether to preserve the base Tailwind colours or not
 * @returns The tailwind theme
 */
export function getTailwindTheme(preserveColours) {
    const tailwindTheme = {
        extend: {
            columns: {},
            screens,
            backgroundImage: {
                "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
                "gradient-conic": "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
            },
            animation,
            keyframes,
        },
    };
    const typography = () => ({
        DEFAULT: {
            css: {
                "--tw-prose-links": removeAlpha(baseColours.deepocean[500]),
                "--tw-prose-invert-links": removeAlpha(baseColours.deepocean[500]),
            },
        },
    });
    if (preserveColours) {
        tailwindTheme.extend = {
            ...tailwindTheme.extend,
            colors: baseColours,
            typography,
        };
    }
    else {
        tailwindTheme.colors = baseColours;
        tailwindTheme.extend = {
            ...tailwindTheme.extend,
            typography,
        };
    }
    return tailwindTheme;
}
const defaultExport = { theme: getTailwindTheme(true) };
export default defaultExport;
//# sourceMappingURL=index.js.map